import { useIsRemoteIntroPromoEligible } from './eligibility/useIsRemoteIntroPromoEligible';
import type { RemoteIntroPromoHost } from './remote-intro-promo-host.types';
import { useRemoteIntroPromoSeen } from './useRemoteIntroPromoSeen';

/**
 * Returns `true` only while the profile-menu promo card is actually going to
 * render — i.e. the user is in an eligible cohort AND hasn't dismissed /
 * engaged with the promo yet. Mirrors the visibility check inside
 * `RemoteIntroPromoMenuCard` so callers that need to *react* to the card's
 * presence (e.g. widening the avatar-dropdown popover so the title row fits)
 * don't have to recompose the eligibility + seen-state gates themselves.
 */
export function useIsRemoteIntroPromoMenuCardVisible(
  host: RemoteIntroPromoHost
): boolean {
  const isEligible = useIsRemoteIntroPromoEligible(host);
  const { isSeen } = useRemoteIntroPromoSeen(host);
  return isEligible && !isSeen;
}
